export const contentTypes = {
  VEHICLE: 'ContentfulVehicle',
  AUTOMOBILIA: 'ContentfulAutomobilia',
};
